export default {
  fields: {
    discount: {
      label: 'Alennus',
    },
    usage_threshold: {
      label: 'Tilauksen vähimmäissumma',
    },
    max_discount: {
      label: 'Alennuksen enimmäismäärä',
    },
  },
};
